// @ts-strict-ignore
import { ReactNode, useRef } from 'react';

import { Box } from 'components/Box';
import { Flex } from 'components/Flex';
import { Hide } from 'components/Hide';
import { IdealistLogoLegacy } from 'components/Logo';
import { H5 } from 'components/Text/H5';
import { CmsApiStickyHeaderLinkData } from 'modules/cms/api/types/CmsApiStickyHeaderLinks';
import { colors, gutterWidth } from 'theme';
import { useSticky } from 'utils/screen';

import { CmsStickyHeaderLinksContainer } from './CmsStickyHeaderLinksContainer';
import { CmsStickyHeaderLinksList } from './CmsStickyHeaderLinksList';

type Props = {
  links: Array<CmsApiStickyHeaderLinkData>;
  button?: ReactNode;
};

export function CmsStickyHeaderLinks({ links, button }: Props) {
  const ref = useRef<HTMLDivElement>();

  const sticky = useSticky({ ref, onlyIfScrolledPast: true });

  const hasButton = typeof button !== 'undefined';

  return (
    <>
      <Box boxShadow="0 2px 6px 0 rgba(0, 0, 0, 0.075)">
        <Hide lg xl>
          <Box mb="12px" pt="12px">
            <H5 color={colors.battleshipGrey} textAlign="center">
              On this page
            </H5>
          </Box>
        </Hide>

        <CmsStickyHeaderLinksList links={links} />
      </Box>

      <div ref={ref}>
        <Hide xs sm md>
          <CmsStickyHeaderLinksContainer
            isSticky={sticky}
            py={14}
            px={gutterWidth / 2}
          >
            <Box component="a" href="/" flex="0 0 auto">
              <IdealistLogoLegacy height={49} />
            </Box>

            <CmsStickyHeaderLinksList
              links={links}
              isSticky
              hasButton={hasButton}
            />

            {hasButton && (
              <Flex minWidth={160} justifyContent="flex-end">
                {button}
              </Flex>
            )}
          </CmsStickyHeaderLinksContainer>
        </Hide>
      </div>
    </>
  );
}
